import React from "react";
import { connect } from "react-redux";

import InformacionDePerfil from "./informacionDePerfil.cmpt.js";
import DatosPersonales from "./datosPersonales.cmpt.js";
import Seguridad from "./seguridad.cmpt.js";
import DatosFiscales from "./datosfiscales.cmpt.js";
import RedesSociales from "./redes.cmpt.js";
import ContactoDeEmergencia from "./contactoDeEmergencia.cmpt.js";
import Documentos from "./documentos.cmpt.js";
import Cuenta from "./cuenta.cmpt.js";
import ModalCambiarContrasena from "./modalCambiarContrasena.cmpt.js";
import ModalCambiarPreguntas from "./modalCambiarPreguntas.cmpt.js";
import ModalEliminarCuenta from "./modalEliminarCuenta.cmpt.js";
import ModalRedesSociales from "./modalRedesSociales.cmpt.js";
import {
  cargarDatosPersonales,
  cargarPreguntas,
  cargarDatos,
  cargarParentescos,
} from "./datos.act";

const mapState = (state) => {
  return {
    loading: state.global.loading,
  };
};

const mapDispatch = (dispatch) => {
  return {
    cargarDatosPersonales: () => {
      dispatch(cargarDatosPersonales());
    },
    cargarPreguntas: () => {
      dispatch(cargarPreguntas());
    },
    cargarDatos: () => {
      dispatch(cargarDatos());
    },
    cargarParentescos: () => {
      dispatch(cargarParentescos());
    },
  };
};

class Datos extends React.Component {
  state = {};

  componentWillMount = () => {
    this.props.cargarDatosPersonales();
    this.props.cargarPreguntas();
    this.props.cargarDatos();
    this.props.cargarParentescos();
  };

  render() {
    return (
      <div className="container">
        <div className="row">
          <InformacionDePerfil />
          <div className="col-xs-12 col-md-6">
            <div className="row">
              <DatosPersonales />
              <Seguridad />
              <DatosFiscales />
              <RedesSociales />
            </div>
          </div>
          <div className="col-xs-12 col-md-6">
            <div className="row">
              <ContactoDeEmergencia />
              <Documentos />
              <Cuenta />
            </div>
          </div>
        </div>
        <div
          className="modal fade modal-msj"
          id="modal-editar-contrasena"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="modal-editar-contrasenaLabel"
          data-backdrop="static"
          data-keyboard="false"
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <ModalCambiarContrasena />
            </div>
          </div>
        </div>
        <div
          className="modal fade modal-msj"
          id="modal-editar-preguntas"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="modal-editar-preguntasLabel"
          data-backdrop="static"
          data-keyboard="false"
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <ModalCambiarPreguntas />
            </div>
          </div>
        </div>
        <div
          className="modal fade modal-msj"
          id="modal-eliminar-cuenta"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="modal-eliminar-cuentaLabel"
          data-backdrop="static"
          data-keyboard="false"
        >
          <div className="modal-dialog " role="document">
            <div className="modal-content">
              <ModalEliminarCuenta />
            </div>
          </div>
        </div>
        <div
          className="modal fade modal-msj"
          id="modal-redes-sociales"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="modal-redes-socialesLabel"
          data-backdrop="static"
          data-keyboard="false"
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <ModalRedesSociales />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(mapState, mapDispatch)(Datos);



// WEBPACK FOOTER //
// ./src/miPerfil/datos.cmpt.js